import { useEffect, useLayoutEffect } from 'react'

/**
 * useIsomorphicLayoutEffect
 *
 * A hook that uses useLayoutEffect on the client and useEffect on the server.
 * This prevents SSR warnings about useLayoutEffect not being available during server rendering.
 *
 * @see https://react.dev/reference/react/useLayoutEffect#caveats
 */
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect

export default useIsomorphicLayoutEffect
